import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-14 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20artistic%20background%2C%20warm%20coral%20and%20orange%20gradient%20abstract%20illustration%2C%20soft%20flowing%20curves%2C%20modern%20digital%20art%2C%20gentle%20dynamic%20shapes%2C%20clean%20professional%20design%2C%20warm%20inviting%20atmosphere&width=1600&height=600&seq=cta-bg-comic&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-700/85 to-secondary-700/85"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-bold text-background-50 mb-3 font-heading">
          海量韩漫，免费畅读
        </h2>
        <p className="text-sm md:text-base text-background-200/90 mb-8 max-w-lg mx-auto leading-relaxed">
          随时随地在线阅读最新韩国漫画，无广告打扰，沉浸式阅读体验。加入数百万读者的韩漫乐园！
        </p>
        <Link
          to="/category/rexue"
          className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-600 rounded-full font-semibold text-sm hover:bg-background-100 transition-all whitespace-nowrap"
        >
          立即开始阅读
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </div>
        </Link>
      </div>
    </section>
  );
}